// extracted by mini-css-extract-plugin
module.exports = {"loadingCard":"LoadingCard_loadingCard__W5QLG","spinner":"LoadingCard_spinner__kdbrZ","loadAnimation":"LoadingCard_loadAnimation__hrdTS"};